module.exports = __webpack_public_path__ + "media/theme/tutorial__psn--4--redeem-f6916453.png";